import type { CustomFieldDefinition, CustomFieldTexts } from '../schema/customFields';

/** One field as hosts and the order payload see it — the legacy shape. */
export interface CustomFieldEntry {
    value: string;
    /** The field's name from the component settings. */
    title: string;
    /** `title` as an identifier, e.g. "Checkout-Titel" → "checkout-titel". */
    id: string;
}

/**
 * Join stored texts with their definitions, keyed by field number. Texts of a
 * field that no longer exists are left out. Same shape legacy wrote into
 * `customFields` / `choiceCustomFields` (option/abstract.js getCustomFields).
 */
export function resolveCustomFields(
    texts: CustomFieldTexts,
    definitions: readonly CustomFieldDefinition[],
): Record<string, CustomFieldEntry> {
    const out: Record<string, CustomFieldEntry> = {};
    for (const def of definitions) {
        const value = texts[String(def.id)];
        if (value === undefined) continue;
        out[String(def.id)] = { value, title: def.name, id: idFromLabel(def.name) };
    }
    return out;
}

/** Legacy `App_Helper.getIdFromLabel`, step for step, so ids match legacy. */
export function idFromLabel(label: string): string {
    return label
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/[><]/g, '')
        .replace(/[|,.\\]/g, '_')
        .replace(/[()/]/g, '')
        .replace(/[äöüÄÖÜß&§$%'"´`?=)(^°!+]/g, '')
        .replace(/:/g, '-')
        .replace(/[*"'<>]/g, '')
        .toLowerCase();
}
